import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { ClientDetailPage } from '@/features/clients';
import { ClientDetailSearchSchema } from '@/features/clients/search';

/** One client: profile and contacts tabs (the open tab is in the address). */
export const Route = createFileRoute('/_auth/o/$orgId/clients/$clientId')({
  validateSearch: (search) => ClientDetailSearchSchema.parse(search),
  component: ClientRoute,
});

function ClientRoute() {
  const { orgId, clientId } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <ClientDetailPage
      orgId={orgId}
      clientId={clientId}
      tab={tab ?? 'profile'}
      onTabChange={(next) => {
        void navigate({ search: { tab: next === 'profile' ? undefined : next }, replace: true });
      }}
    />
  );
}
